export default [
  //    - General settings
  {
    path: "/settings",
    name: "foravila-general-settings",
    component: () => import("@/views/settings/GeneralSettings.vue"),
    meta: {
      action: "manage",
      resource: "all",
    },
  },
];
